import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { CookiesProvider } from 'react-cookie'
import config from '@adc/configment'
import { MorpheusApplicationContext } from '@adc/ui-morpheus'
import { primitives } from '@adc/blueprint'
import configureStore from '../common/store'
import App from '../common/containers/app.jsx'
import { prefetchHighPriorityRoutes } from '../common/components/commandPalette/prefetchRoutes'

const store = configureStore(window.INITIAL_STATE)
const graphWebsocket = new primitives.GraphWebsocket()

// Client-side render (CSR): the server sent an app-shell skeleton into this
// mount node; React 18's createRoot renders the real app into the same node,
// replacing the skeleton. No hydration — the shell is non-React markup.
const root = createRoot(window.ROOT_DOM_MOUNT)
root.render(
  <MorpheusApplicationContext.ApplicationContextProvider
    graphWebsocket={graphWebsocket}
  >
    <Provider store={store}>
      <BrowserRouter basename={config.get('URL_BASE_PREFIX')}>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </BrowserRouter>
    </Provider>
  </MorpheusApplicationContext.ApplicationContextProvider>
)

// Background-warm the most common route chunks once the main thread is idle.
prefetchHighPriorityRoutes()

// Service worker: precache/serve static build assets in prod only (SW + HMR
// conflict in dev). It caches only assets under /page-assets/, so it runs at
// its own default scope — no root scope or Service-Worker-Allowed header
// needed. Graph/API traffic is deliberately never touched by the SW (see
// webpack.client.js: NetworkOnly) so a bid/mutation is never served stale.
// Registration is best-effort — a failure never blocks the app.
if (__PROD__ && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const basePrefix = config.get('URL_BASE_PREFIX', '')
    navigator.serviceWorker
      .register(`${basePrefix}/page-assets/service-worker.js`)
      .catch(() => {})
  })
}
